var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg150(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2560_5585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.826652 16C0.615892 16 0.405133 15.9199 0.245004 15.7585C-0.0764596 15.4371 -0.0764596 14.9159 0.245004 14.5944L14.5983 0.241098C14.9198 -0.0803659 15.441 -0.0803659 15.7624 0.241098C16.0839 0.562561 16.0839 1.08373 15.7624 1.4054L1.4093 15.7585C1.24797 15.9189 1.03721 16 0.826652 16Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.181 16C14.9702 16 14.7597 15.9199 14.5994 15.7585L0.245004 1.4054C-0.0764596 1.08373 -0.0764596 0.562561 0.245004 0.241098C0.566467 -0.0803659 1.08764 -0.0803659 1.4093 0.241098L15.7624 14.5944C16.0839 14.9159 16.0839 15.4371 15.7624 15.7585C15.6011 15.9189 15.3906 16 15.181 16Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2560_5585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg150);
export default __webpack_public_path__ + "static/media/svg150.a891209512455f546b45bd9224383696.svg";
export { ForwardRef as ReactComponent };